var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"education-main"},[_c('div',{staticClass:"educationStyle",attrs:{"id":"education"}})])
}]

export { render, staticRenderFns }